export default __webpack_public_path__ + "static/media/hero-video-tablet.ded7dae0.jpg";